module.exports = {"469006100":"万城镇","469006101":"龙滚镇","469006102":"和乐镇","469006103":"后安镇","469006104":"大茂镇","469006105":"东澳镇","469006106":"礼纪镇","469006107":"长丰镇","469006108":"山根镇","469006109":"北大镇","469006110":"南桥镇","469006111":"三更罗镇","469006500":"兴隆华侨农场","469006501":"地方国营六连林场"}


//////////////////
// WEBPACK FOOTER
// ./src/town/469006.json
// module id = 2200
// module chunks = 0